import React, { useContext, useEffect, useState } from 'react'
import { formatDate, getSampleCsvHeadings, ROUTES } from '../../../shared/constants'
import { useHistory } from 'react-router'
import { useAuditQuestions } from '../../../hooks/Others/Audit/useAuditQuestions'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useDownload } from '../../../hooks/Download/useDownload'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'

export default function AuditQuestion() {
  const { getAllAuditQuestion, deleteManyAuditQuestion, loading, paginate, updateAuditQuestion } = useAuditQuestions()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { auditQuestions } = useContext(OtherContext)
  //console.log('auditQuestions : ', auditQuestions)
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterAuditQuestion = auditQuestions
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllAuditQuestion({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_AUDITQUESTION')
  }, [])

  const handleChange = (event, value) => setPage(value)

  let tableBody = []

  if (!loading && filterAuditQuestion.length > 0) {
    tableBody = filterAuditQuestion.map((item) => {
      return [
        { value: formatDate(item.auditDate) },
        { value: item.auditCode },
        { value: item.totalQuestions },
        { value: item.totalPoints },
        { type: 'INFO', onClick: () => history.push(`/view-audit-question/${item.auditDate}`) },
      ]
    })
  }
  const sampleHeaders = getSampleCsvHeadings(['auditCode', 'auditDate', 'question', 'points'])
  const layoutProps = {
    heading: 'Audit Questions',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    // filename: 'auditQuestions',
    // headers: pdfCsvData.headings,
    // data: pdfCsvData.headingValues,
    downloadLoading,
    permissionName: 'AUDIT',
    sampleName: 'sample_auditQuestion',
    sheetName: 'auditQuestion',
    tempHeaders: sampleHeaders,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Audit Date', 'audit code', 'Total Audit Questions', 'Total Points', 'Info']}
      loading={loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      deleteMany={(val, setSelected) => deleteManyAuditQuestion({ auditQuestionId: val }, setSelected)}
    />
  )
}
